import React, {forwardRef, useImperativeHandle, useState} from "react";
import {imgPathPerfix} from "../../utils";
import {useTranslation} from "react-i18next";
import {ConfigProvider, Select} from "antd";
import {IconDropdownGray, IconDropdownWhite} from "@/Icon";

const PopoverExportFrame = forwardRef((props:{onClosePopover:any,onDoneEvent:any}, ref)=>{
    useImperativeHandle(ref,()=>({
        onShowDialog:onShowDialog
    }))

    const {t} = useTranslation();

    const [exportType,setExportType] = useState('png');
    const [pageType,setPageType] = useState('current');

    const onShowDialog = (szExportType:any)=>{
        setExportType(szExportType);
    }

    return(
        <div className='flex-col'>
            <div className='flex-row-vertical-center'>
                <img className='img-16'
                     src={imgPathPerfix() + (exportType === 'png' ? "menu_frame_export.png" : "menu_frame_export.png")}/>
                <span className='ml-8'>{exportType === 'png' ? t("Output png") : t("Export as Pdf")}</span>
            </div>
            <ConfigProvider
                theme={{
                    components: {
                        Select: {
                            /* 这里是你的组件 token */
                            colorBgElevated:'#2C2C2C',
                            colorBgContainer:'#2C2C2C',
                            colorBorder:'#525252',
                            colorPrimary:'white',
                            colorText:'white',
                            fontSize:12,
                            optionSelectedBg:'#525252',
                            colorTextPlaceholder:'white',
                            colorPrimaryHover:'#525252'
                        },
                    },
                }}
            >
                <Select
                    suffixIcon={<IconDropdownWhite/>}
                    defaultValue='current'
                    style={{ width: '100%',marginTop:'16px' }}
                    options={[
                        { value: 'current', label: t("All frames on current board") },
                        { value: 'all', label: t("All frames on all board") }
                    ]}
                    onChange={(e)=>{
                        setPageType(e);
                    }}
                    value={pageType}
                />
            </ConfigProvider>

            <div className='flex-row-vertical-center mt-16'>
                <div style={{flexGrow:'1'}}></div>
                <span className='flex-center cursor-pointer' style={{height:'32px'}} onClick={()=>{
                    props.onClosePopover();
                }}>{t("Cancel")}</span>
                <span className='button-solid-style flex-center ml-16 cursor-pointer' style={{height:'32px',minWidth:'70px'}}
                onClick={()=>{
                    props.onDoneEvent(exportType,pageType);
                }}>{t("Export")}</span>
            </div>
        </div>
    )
})

export default PopoverExportFrame;





















